// extracted by mini-css-extract-plugin
module.exports = {"container":"_d2308151","visuallySimilarWrapper":"_d25b4fe5 _6c3baef9"};